import { colors } from '@thndr/design-system';
import styled from 'styled-components';
import { Modal as AntdModal, Button as antdButton } from 'antd';
import { newFonts as fonts, fontsArabic } from '../../../../../src/theme';
interface IContainerProps {
  hasError: boolean;
}

export const Container = styled.div<IContainerProps>`
  padding: 20px;
  background: #ffffff;
  max-width: 340px;
  min-width: 340px;
  border: 1px solid ${(props) => (props.hasError ? colors.red30 : colors.black)};
  box-shadow: ${(props) =>
    props.hasError ? `4px 4px 0px ${colors.red30}` : 'none'};
  border-radius: 16px;

  @media (max-width: 700px) {
    min-width: 350px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: max-content;
  height: 100%;
`;

export const Title = styled.h5`
  margin-bottom: 0px;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: ${colors.black};
  font-family: ${({ theme }) =>
    theme.rtl
      ? fontsArabic.mediumRegular.fontFamily
      : fonts.mediumRegular.fontFamily};
`;

export const BrandImage = styled.img`
  margin-inline-end: 5px;
  object-fit: contain;
  width: 35px;
`;
export const EgyImage = styled.img`
  margin-inline-end: 5px;
  object-fit: contain;
  width: 27px;
`;

export const Date = styled.p`
  display: flex;
  justify-content: flex-end;
  padding-inline-end: 3px;
  transform: translateY(-3px);
  font-family: ${({ theme }) =>
    theme.rtl ? fonts.smallRegular.fontFamily : fonts.smallRegular.fontFamily};
`;
export const Bold = styled.h3`
  font-weight: 700;
  margin-bottom: 0px;
  font-family: ${({ theme }) =>
    theme.rtl ? fonts.smallRegular.fontFamily : fonts.smallRegular.fontFamily};
`;

export const ChangeButton = styled(antdButton)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 11px 8px;
  gap: 4px;
  width: 100%;
  background: ${colors.black};
  color: white;
  border-radius: 8px;
  cursor: pointer;
  font-family: ${({ theme }) =>
    theme.rtl
      ? fontsArabic.mediumRegular.fontFamily
      : fonts.mediumRegular.fontFamily};
`;

export const Flex = styled.div`
  display: flex;
  align-items: center;
`;
export const WalletContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-inline-start: 20px;
  padding: 20px;
  background: #ffffff;
  max-width: 340px;
  min-width: 340px;
  border: 1px solid ${colors.black};
  border-radius: 16px;
  @media only screen and (max-width: 700px) {
    min-width: 350px;
    margin-left: 0;
    margin: auto;
  }
  div {
    gap: 8px;
  }
`;
export const WalletWithBalanceContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 16px;
  background: #ffffff;
  max-width: 350px;
  min-width: 200px;
  border: 1px solid ${colors.black};
  border-radius: 16px;
  div {
    gap: 8px;
  }
`;
export const WalletTitleBalanceContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;
export const Error = styled.h4`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: ${colors.red50};
  font-family: ${({ theme }) =>
    theme.rtl
      ? fontsArabic.mediumRegular.fontFamily
      : fonts.mediumRegular.fontFamily};
`;

export const PaymentMethodLink = styled.a`
  color: #4683f3;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  font-family: ${({ theme }) =>
    theme.rtl
      ? fontsArabic.mediumRegular.fontFamily
      : fonts.mediumRegular.fontFamily};
`;
export const DiscountDisclaimer = styled.h4`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px;
  gap: 8px;
  width: 95%;
  margin: auto;
  margin-bottom: 5px;
  background: #ebffeb;
  border-radius: 12px;
  font-family: ${({ theme }) =>
    theme.rtl
      ? fontsArabic.mediumRegular.fontFamily
      : fonts.mediumRegular.fontFamily};
`;

export const StyledToolTip = styled.img`
  cursor: pointer;
  width: 13px;

  margin-inline-start: 5px;
`;

export const Modal = styled(AntdModal)`
  .ant-modal-body {
    background: ${colors.green200};
  }
  background: ${colors.green200};

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 10px;
  border: 1px solid #1a1a1a;
  box-shadow: 4px 4px 0px #000000;
  border-radius: 12px;
`;

export const Modaltitle = styled.h1`
  font-weight: 900;
  font-size: 30px;
  line-height: 28px;
  text-align: center;
  margin-bottom: 30px !important;
  color: #000000;
  font-family: ${({ theme }) =>
    theme.rtl
      ? fontsArabic.mediumBold.fontFamily
      : fonts.mediumBold.fontFamily};
`;

export const ModalSubtitle = styled.li`
  font-weight: 400;
  font-size: 18px;
  line-height: 30px;
  color: ${colors.black};
  font-family: ${({ theme }) =>
    theme.rtl
      ? fontsArabic.mediumRegular.fontFamily
      : fonts.mediumRegular.fontFamily};
`;

export const ModalButton = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 16px;
  margin-top: 20px !important;
  gap: 4px;
  width: 60%;
  margin: auto;
  background: #1a1a1a;
  color: white;
  border: 1px solid #1a1a1a;
  border-radius: 40px;
  cursor: pointer;
  font-family: ${({ theme }) =>
    theme.rtl
      ? fontsArabic.mediumRegular.fontFamily
      : fonts.mediumRegular.fontFamily};
`;
export const WalletTitle = styled.p`
  color: #000;
  font-family: DM Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  display: flex;
  gap: 8px;
  align-items: center;
`;
export const WalletSubtitle = styled.p`
  color: #000;
  font-family: DM Sans;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
`;
